import React from "react";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";


export default class FFLLookup extends CollectionOverride {
	constructor(props) {
		super(props, Types.Ffls._name);
		this.state.limit = 10;
		this.limit = 10;
		this.state.lastSearch = null;
		this.state.search = this.props.currentFFL ?? '';
	}

	static getDerivedStateFromProps(nextProps, prevState){
		if(prevState.search === '' && prevState.lastSearch !== '' && (nextProps.currentFFL !== '' && nextProps.currentFFL)){
			return {
				search: nextProps.currentFFL,
				lastSearch: prevState.search
			};
		}
		else return null;
	}

	addToDealer = (ffl) => () => {
		if (typeof this.props.afterSave !== 'undefined') {
			this.props.afterSave(ffl);
		}
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<Button color="blue-hoki" size={"sm"} block={true} onClick={this.addToDealer(props.original)}>
							<i className={"fa fa-plus"}/></Button>
					);
				}
			},
			{
				Header: "FFL",
				accessor: 'ffl',
				width: 160
			},
			{
				Header: "License Name",
				accessor: "name_license",
			},
			{
				Header: "Trade Name",
				accessor: "name_business",
			},
			{
				Header: "Type",
				id: "oct_4",
				/** @param {Ffls_Object} obj */
				accessor: obj => {
					return obj.oct_4;
				},
				width: 55
			},
			{
				Header: "Expiration",
				id: "expiration",
				filterable: false,
				sortable: false,
				/** @param {Ffls_Object} obj */
				accessor: obj => {
					let evaluationYear = new Date().getFullYear();
					let expirationOct = obj.oct_5;
					let month = expirationOct.substring(1, 2).alphaToMonth();
					let year = expirationOct.substring(0, 1).numToYear(evaluationYear);
					return month + ' ' + year;
				},
				width: 90
			},
			{
				Header: "Street",
				accessor: "street",
			},
			{
				Header: "City",
				accessor: "city",
			},
			{
				Header: "State",
				accessor: "state",
				width: 58
			},
			{
				Header: "Zip",
				id: 'zip',
				accessor: obj => obj.zip.substring(0, 5),
				width: 65
			},
			{
				Header: "Phone",
				accessor: "phone",
				width: 95
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('FFLs', "")}
								{this.renderStateFilter()}
								{this.renderHeaderRight("FFLs", columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
